<template>
    <v-card flat class="pa-4">
        <v-form ref="form">
            <v-row dense>
                <!-- ID + Name -->
                <v-col cols="2" class="pt-4 text-center">
                    <v-label class="id-label">Area ID {{ area.id }}</v-label>
                </v-col>
                <v-col cols="10" class="">
                    <v-text-field
                        v-model="area.name"
                        label="Name"
                        variant="outlined"
                        density="compact"
                        :readonly="!isEditing"
                        :rules="[rules.required]"
                        :lazy-rules="false"
                    />
                </v-col>

                <!-- Radius + Coordinates -->
                <v-col cols="3">
                    <v-text-field
                    v-model="area.radius"
                    label="Radius (m)"
                    type="number"
                    variant="outlined"
                    density="compact"
                    :readonly="!isEditing"
                    :rules="[rules.required, rules.number, rules.positive]"
                    :lazy-rules="false"
                    />
                </v-col>
                <v-col cols="3">
                    <v-text-field
                    v-model="area.center[0]"
                    label="Longitude"
                    variant="outlined"
                    density="compact"
                    :readonly="!isEditing"
                    :rules="[rules.required, rules.number]"
                :lazy-rules="false"
                />
                </v-col>
                <v-col cols="3">
                    <v-text-field
                    v-model="area.center[1]"
                    label="Latitude"
                    variant="outlined"
                    density="compact"
                    :readonly="!isEditing"
                    :rules="[rules.required, rules.number]"
                    :lazy-rules="false"
                    />
                </v-col>
                <v-btn
                    v-if="!isCircleDrawing"
                    variant="text"
                    color="primary"
                    class="pa-0 text-decoration-underline mt-2 text-body-2 text-normal-case"
                    @click="startCircleDraw"
                    :disabled="!isEditing"
                >
                    Pick coordinates on map
                </v-btn>
                <v-btn
                    v-if="isCircleDrawing"
                    variant="text"
                    color="green"
                    class="pa-0  mt-2 text-body-2 text-normal-case"
                    style="pointer-events: none;"
                >
                    Click on the map to start drawing
                </v-btn>
                
                <!-- Description -->
                <v-col cols="12">
                    <v-textarea
                    v-model="area.description"
                    label="Description"
                    rows="1"
                    variant="outlined"
                    density="comfortable"
                    :readonly="!isEditing"
                    />
                </v-col>


                <!-- Read-only metadata -->
                <v-col cols="3">
                    <v-label>Last Updated By</v-label>
                    <div class="readonly-value">{{ area.updatedBy || '-' }}</div>
                </v-col>
                <v-col cols="3">
                    <v-label>Last Updated At</v-label>
                    <div class="readonly-value">{{ area.updatedAt || '-' }}</div>
                </v-col>
                <v-col cols="3">
                    <v-label>Status</v-label>
                    <div class="readonly-value">{{area.active ? 'Enabled' : 'Disabled'}}</div>
                </v-col>
                <v-col cols="3">
                    <v-label>Disabled By</v-label>
                    <div class="readonly-value">{{ area.disabledBy || '-' }}</div>
                </v-col>
            </v-row>
        </v-form>
    </v-card>
</template>

<script>
export default {
    name: "ExclusionAreaEditForm",
    props: {
        selectedArea: {
            type: Object,
        },
        positionUpdate:{
            type: Object,
        },
        isEditing: {
            type: Boolean,
            default: false
        },
        isCircleDrawing: {
            type: Boolean,
            default: false
        },
        triggerSend: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            rules: {
                required: value => !!value || 'Can not be empty',
                number: v => !isNaN(v) || 'Must be a number',
                positive: v => v >= 0 || 'Must be a positive number'
            },
            area: null,
        };
    },
    methods: {
        startCircleDraw() {
            this.$emit('circleDrawStart');
        },
        submitForm() {
            if (this.$refs.form.validate()) {
                this.$emit('submit', this.selectedArea);
            }
        }
    },
    watch: {
        selectedArea: {
            immediate: true,
            handler(newArea) {
                if (newArea) {
                    this.area = { ...newArea };
                }else {
                    this.area = null;
                }
            },
            deep:true
        },
        positionUpdate:{
            immediate: true,
            handler(newPosition) {
                if (newPosition && newPosition.radius && newPosition.center?.length === 2) {
                    this.area.center = newPosition.center;
                    this.area.radius = newPosition.radius;
                }
            }
        },
        triggerSend: {
            immediate: true,
            async handler(newValue) {
                if (newValue && this.area) {
                    const valid = await this.$refs.form.validate();
                    if(valid.valid){
                        this.$emit('send', this.area);

                    }
                    else{
                        this.$emit('error');
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
.readonly-value {
  padding: 8px 0;
  color: #444;
  font-size: 14px;
}
.id-label{
    font-size: 20px;
}
</style>